import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Fund from "../../components/fund/fund";
import HeaderDashboard from "../../components/layout/header/HeaderDashboard";
import GocardLessInfoModal from "../../components/modals/GocardLessInfoModal";
import LoginAsUser from "../../components/loginasuser/LoginAsUser";
import { headerData } from "../../locales/en";
import "./../../assets/scss/home.scss";
import useProfile from "../../hooks/useProfile";
import useLoginSuccessToast from "../../hooks/login/useLoginSuccessToast";
import AccountingSoftConnectedModal from "../../components/modals/AccountingSoftConnectedModal";
import { useDispatch, useSelector } from "react-redux";
import { getActiveBnrNotification } from "../../redux/bannerNotificationSlice";
import { useToast } from "../../hooks/useToast";

function Home() {
  useLoginSuccessToast();
  const dispatch = useDispatch();
  const toast = useToast();
  const location = useLocation();
  const { getConnectedSoftwareData } = useSelector((state) => state.login);
  const [gocardlessModal, setGocardlessModal] = useState(false);
  const [profileUserData, setProfileUserData] = useState({});
  const [connectedSoftwareModal, setConnectedSoftwareModal] = useState(true);
  const { profile } = useProfile();
  const isConnected = getConnectedSoftwareData?.isConnected;

  const [bannerNotiData, setBannerNotiData] = useState(null);

  const handleConnectedSoftwareToggle = () => {
    setConnectedSoftwareModal(!connectedSoftwareModal);
  };

  const handleGocardlesToggle = () => {
    setGocardlessModal(!gocardlessModal);
  };

  useEffect(() => {
    if (location.state?.showGoCardlessModal) {
      setGocardlessModal(true);
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  useEffect(() => {
    if (profile && profile?.id) {
      setProfileUserData(profile);
    }
  }, [profile]);

  const shouldShowNotification = (notification) => {
    if (!notification?.isActive) {
      return false;
    }
    if (
      notification?.expiresAt &&
      new Date(notification.expiresAt) <= new Date()
    ) {
      return false;
    }
    return true;
  };

  useEffect(() => {
    const handleGetNotificationData = async () => {
      try {
        const response = await dispatch(getActiveBnrNotification()).unwrap();

        const notifications = response?.data?.data ?? [];
        const notification = notifications.find(shouldShowNotification);

        setBannerNotiData(notification ?? null);
      } catch (error) {
        toast.error(error);
      }
    };

    handleGetNotificationData();
  }, [dispatch]);

  return (
    <>
      <HeaderDashboard />

      <LoginAsUser />

      <div className="home-main-section">
        <div className="container">
          <div className="home-title">
            {bannerNotiData ? (
              <p className="notification-content">{bannerNotiData?.message}</p>
            ) : null}
            <h1>{headerData?.myInvoices}</h1>
          </div>
        </div>
        <Fund profileUserData={profileUserData} />
      </div>
      <GocardLessInfoModal
        isOpen={gocardlessModal}
        toggle={handleGocardlesToggle}
      />

      {!isConnected && !gocardlessModal && (
        <AccountingSoftConnectedModal
          isOpen={connectedSoftwareModal}
          toggle={handleConnectedSoftwareToggle}
        />
      )}
    </>
  );
}
export default Home;
